var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C37.7025 5.15406e-07 48 10.2975 48 23V25C48 37.7025 37.7025 48 25 48H23C10.2975 48 0 37.7025 0 25V23C5.1544e-07 10.2975 10.2975 0 23 0H25Z",
    fill: "#FFF0D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7679 22.7943C19.658 22.7837 19.5263 22.7837 19.4054 22.7943C16.7916 22.709 14.7159 20.629 14.7159 18.069C14.7159 15.4557 16.8904 13.333 19.5922 13.333C22.2829 13.333 24.4685 15.4557 24.4685 18.069C24.4575 20.629 22.3817 22.709 19.7679 22.7943Z",
    stroke: "#E89A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7337 15.4673C29.8644 15.4673 31.5777 17.142 31.5777 19.2006C31.5777 21.2166 29.9303 22.8593 27.8765 22.934C27.7887 22.9233 27.6898 22.9233 27.591 22.934",
    stroke: "#E89A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2767 26.7311C11.6189 28.4591 11.6189 31.2751 14.2767 32.9924C17.2969 34.9551 22.2501 34.9551 25.2704 32.9924C27.9282 31.2644 27.9282 28.4484 25.2704 26.7311C22.2611 24.7791 17.3079 24.7791 14.2767 26.7311Z",
    stroke: "#E89A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8513 32.5333C30.642 32.3733 31.3889 32.064 32.0039 31.6053C33.7172 30.3573 33.7172 28.2986 32.0039 27.0506C31.3998 26.6026 30.664 26.304 29.8842 26.1333",
    stroke: "#E89A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSquare);
export default __webpack_public_path__ + "static/media/profileSquare.3ab635fa4148263d836ff241ae028f1b.svg";
export { ForwardRef as ReactComponent };